export enum PropertyStatus {
  TRENDING = 'TRENDING',
  SOLD_OUT = 'SOLD_OUT',
  CLOSE = 'CLOSE',
  COMING_SOON = 'COMING_SOON',
  NEW = 'NEW',
  OWNER = 'OWNER',
  FUTURE_MARKET = 'FUTURE_MARKET',
  PAUSED = 'PAUSED',
  LIMITED_OFFERING = 'LIMITED_OFFERING',
}
